/* eslint-disable jira/filename-case */
export const performanceKeyPrefix = 'jira.fe.spa-';

export const SPA_APP_START: 'jira.fe.spa-start' = `${performanceKeyPrefix}start`;

export const SPA_SSR_RENDERED = 'ssr.spa.rendered';

export const APP_BUNDLE_READY = 'appBundleReady';
export const PREFETCH_API_READY = 'prefetchApiReady';
export const PREFETCH_API_START = 'prefetchApiStart';

export const JSW_RENDER_START = 'jswRenderStart';

export const JSW_CREATE_REDUX_STORE_START = 'jswCreateReduxStoreStart';
export const JSW_CREATE_REDUX_STORE_END = 'jswCreateReduxStoreEnd';

export const JSW_TRANSFORM_CRITICAL_DATA_START = 'jswTransformCriticalDataStart';
export const JSW_TRANSFORM_CRITICAL_DATA_END = 'jswTransformCriticalDataEnd';

export const JSW_REDUX_SOFTWARE_APP_LOADED_START = 'jswReduxSoftwareAppLoadedStart';
export const JSW_REDUX_SOFTWARE_APP_LOADED_END = 'jswReduxSoftwareAppLoadedEnd';

export const TTI_RAF_MARK = 'tti-raf-mark';
export const TTI_RAF_KEY = 'tti-raf';
